
import { Directive, HostListener, Input, ElementRef } from '@angular/core';
import { RestrictType, RestrictRemovePatterns, RestrictAllowedCharPatterns } from '../utils/input-restrict';

@Directive({
	selector: '[appInputRestrict]'
})
export class InputRestrictDirective {

	@Input() appInputRestrict!: RestrictType;
	@Input() maxLength?: number;

	constructor(private el: ElementRef<HTMLInputElement>) { }

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		if (event.ctrlKey || event.metaKey || event.altKey || event.key.length !== 1) {
			return;
		}
		const allowedPattern = RestrictAllowedCharPatterns[this.appInputRestrict];
		if (!allowedPattern.test(event.key)) {
			event.preventDefault();
		}
	}

	@HostListener('input', ['$event'])
	onInput() {
		const input = this.el.nativeElement;
		const pattern = RestrictRemovePatterns[this.appInputRestrict];

		const value = input.value ?? '';
		var sanitized = value.replace(pattern, '');
		if (this.maxLength && sanitized.length > this.maxLength) {
			sanitized = sanitized.substring(0, this.maxLength);
		}

		if (value !== sanitized) {
			input.value = sanitized;
			input.dispatchEvent(
				new Event('input', { bubbles: true })
			);
		}
	}
}